import ResetPasswordPage from './ResetPasswordPage'
import {fullPageLayoutConfig} from '../layout.helper'

export const ResetPasswordPageConfig = {
  settings: {
    layout: fullPageLayoutConfig,
  },
  routes: [
    {
      path: '/reset-password',
      component: ResetPasswordPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/login/ResetPasswordPageConfig.js